import { FC } from "react";
import { Progress } from "antd";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import {MobileBackIcon} from "src/assets/Icons";
import { StepperProps, StepStatus } from "../constants";
import useStepper from "../useStepper";

const StepperMobile: FC<StepperProps> = ({
  steps,
  currentStep,
  onStepChange,
  getStepStatus,
  disableNav,
  renderStepIcon,
  classNames = {},
  onBack,
  backLabel,
  onBackNode,
}) => {
  const { t } = useTranslation();
  const { getStatus, handleStepClick, prevIndex, prevStatus, progressPercent } = useStepper({
    steps,
    currentStep,
    onStepChange,
    getStepStatus,
    disableNav,
  });

  const prevStep = steps[prevIndex];

  const renderStepButton = (index: number, status: StepStatus, step: (typeof steps)[0]) => {
    return (
      <>
        <div className="flex flex-col items-start"> 
          <div className="w-full">Step {currentStep + 1} of {steps.length}</div>
          <div data-status={status} className={cn("text-current font-bold!", classNames.item)}>
            {step.label}
          </div>
        </div>
      </>
    );
  };

  if (!prevStep)
    return onBack || onBackNode ? (
      <div className={cn("flex w-full items-center justify-between text-xs p-2", classNames.root)}>
        {onBackNode ?? (
          <button type="button" onClick={onBack} className="text-font-subtle flex items-center gap-1.5 font-medium">
            <MobileBackIcon className="h-4 w-4" />
            <span>{backLabel ?? t("UserHistory.common.back")}</span>
          </button>
        )}
      </div>
    ) : null;

  return (
    <div className={cn("flex w-full items-center justify-between text-xs px-2", classNames.root)}>
      <button
        data-status={prevStatus ?? "none"}
        onClick={() => prevStep && handleStepClick(prevIndex, getStatus(prevIndex))}
        disabled={!prevStep || prevStatus === "disabled"}
        className="text-font-subtle flex items-center gap-1.5 font-medium disabled:cursor-not-allowed disabled:opacity-30"
      >
        {!disableNav && <MobileBackIcon className="h-4 w-4" />}
        {prevStep && prevStatus && renderStepButton(prevIndex, prevStatus, prevStep)}
      </button>
    </div>
  );
};

export default StepperMobile;
